export default {
  name: '',
  expected: false,
  present: false,
  imgFileName: 'person-default.jpg',
  birthday: {
    day: 1,
    month: 1,
    year: 2000,
  },
  nameday: {
    day: 1,
    month: 1,
  },
};
